
import React from "react";
import { Link } from "react-router-dom";

function EmptyFeedCard({ src ,message, description , btnText , link}) {
  return (
    <div className="p-3 border-6 mt-4 d-flex align-items-center flex-column justify-content-center  mb-2 mw-75 mx-auto">
      <div className="empty-state-icon">
        <img src={src} alt="icon" className="" />
      </div>
      <p className="font-weight-bold">
        {message}
      </p>
      <p className="text-grey-4 text-center fs-14">
        {description}
      </p>
      <Link to={link} className="btn text-primary mt-3 border shadow-2">{btnText}</Link>
    </div>
  );
}

export default EmptyFeedCard;
